const state = () => ({
    navSteps: [
        { id: 1, label: 'Motor', isActive: true, stepConcluded: false, enable: true},
        { id: 2, label: 'Versão', isActive: false, stepConcluded: false, enable: false },
        { id: 3, label: 'Design Exterior', isActive: false, stepConcluded: false, enable: false },
        { id: 4, label: 'Design Interior', isActive: false, stepConcluded: false, enable: false },
        { id: 5, label: 'Resumo', isActive: false, stepConcluded: false, enable: false },
    ],
});

const getters = {
    getNavSteps: state => {
        return state.navSteps
    },
    getValueByKey: state => (id,key) => {
        let res = state.navSteps.find(el => el.id == id)
        return res?.[key]
    }
};

const mutations = {
    RESET_STEPS(state){
        state.navSteps.forEach(el => {
            el.isActive = false
            el.stepConcluded = false
            el.enable = false

            if(el.id == 1){
                el.isActive = true
                el.enable = true
            }
        });
    },
    UPDATE_CURR_ACTIVE(state, payload){
        let currId = payload[0]
        let prevId = payload[1]

        state.navSteps.forEach(el => {
            el.isActive = false
            if(el.id == prevId) el.stepConcluded = true
            if(el.id == currId){
                el.isActive = true
                el.enable = true
            }
        });
    },
};

const actions = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}